module.exports = "/wwwroot/img/recycling_method_page.png?ver=ffa982db";